import React from 'react'

function Backend() {
  return (
    <div className="skills__content">
        <h3 className="skills__tittle">Backend</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">Node.js</h3>
                        
                    </div>
                </div>
                
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">Express</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">Mongoose</h3>
                        
                    </div>
                </div>
               
            </div>
            {/* <div className="skills__group">
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">HTML</h3>
                        
                    </div>
                </div>
                
                <div className="skills__data">
                    <i className='bx bx-badge-check'></i>
                    <div>
                        <h3 className="skills__name">HTML</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                    <i className='bx bx-badge-check'></i>
                    <div>
                        <h3 className="skills__name">HTML</h3>
                        
                    </div>
                </div>
               
            </div> */}
        </div>
    </div>
  )
}

export default Backend